import { MDBContainer } from 'mdbreact';
import React from 'react';
import { connect } from 'react-redux';
import BasePureComponent, { BasePureComponentProps } from '../../components/Shared/BasePureComponent';
import Layout from '../../components/Shared/Layout';
import { Language } from '../../redux/store/base/language';
import Ads from './Ads/Ads';
import Header from './Header/Header';
import Services from './Services/Services';
import Offer from './Offer/Offer';
import Post from './Post/Post';
import Vedio from './../../components/Vedio/Vedio';
import Comment from './../../components/Comment/Comment';
import Footer from './../../components/Footer/Footer';

// Import asset
import "./Home.scss";

class Home extends BasePureComponent<HomeProps> {
    constructor(props: HomeProps) {
        super(props);
    }
    render() {
        return <Layout title={this.props.title}>
            <MDBContainer className="component home" fluid>
                <Header />
                <Ads />
                <Services />
                <Offer />
                <Post />
                <Vedio />
                <Comment />
                <Footer />
            </MDBContainer>
        </Layout>
    }
}

function mapStateToProps(state) {
    return {
        lang: state.lang.dictionary as Language,
    }
}

interface HomeProps extends BasePureComponentProps {
    title: string;
}

export default connect(mapStateToProps)(Home);